import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import { VehicleSuggestionAPIToVehicleSuggestion } from './APITransformer';
import type { VehicleInfoSuggestion, VehicleSuggestionAPI } from './Types';

export class VehicleInfoSuggestions {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getSuggestion = (plate: string): Promise<VehicleInfoSuggestion> => {
    const requestData: IRequest = {
      endpoint: `/vehicle/suggestion?plate=${plate}`,
      method: HttpMethod.GET,
    };

    return this.requester.request(requestData).then((response) => {
      const vehicleSuggestionAPI: VehicleSuggestionAPI = response.data;
      return VehicleSuggestionAPIToVehicleSuggestion(vehicleSuggestionAPI);
    });
  };
}

export default VehicleInfoSuggestions;
